// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileJpgOutlinedSvg from "@fishx/icons-svg/es/asn/FileJpgOutlined";
import FishxIcon from '../components/FishxIcon';

var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileJpgOutlinedSvg
  }));
};

FileJpgOutlined.displayName = 'FileJpgOutlined';
export default React.forwardRef(FileJpgOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileJpgOutlined.js
// module id = 2713
// module chunks = 0